/* =============================================================
   D'Avila — Quick Add ao Carrinho (botao no card do produto)
   - Click no botao adiciona a primeira variante disponivel
   - Dispara evento 'cart:updated' pra notificar outras features
     (ex: barra de progresso, drawer do carrinho)
   ============================================================= */
(function () {
  'use strict';

  // ═══════════════════════════════════════════════════════════════════
  // Attribution de influencer: captura ?ref=CODIGO na URL, salva em
  // localStorage por 30 dias. Cart usa esse code pra sugerir no lugar
  // do "melhor cupom" — attribution do parceiro sempre prevalece.
  // ═══════════════════════════════════════════════════════════════════
  var REF_STORAGE_KEY = 'davila_ref_coupon';
  var REF_TS_KEY = 'davila_ref_coupon_ts';
  var REF_TTL_DAYS = 30;

  function captureRefCouponFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var ref = (params.get('ref') || '').trim().toUpperCase();
      if (!ref) return;
      // Valida formato simples (evita XSS/lixo): letras/numeros/traco/underline, 2-40 chars
      if (!/^[A-Z0-9_\-]{2,40}$/.test(ref)) return;
      localStorage.setItem(REF_STORAGE_KEY, ref);
      localStorage.setItem(REF_TS_KEY, String(Date.now()));
      console.log('[davila-ref] cupom de influencer capturado:', ref);
    } catch (e) { /* localStorage bloqueado, segue */ }
  }

  // Expoe globalmente pra davila-cart.js ler
  window.davilaGetRefCoupon = function () {
    try {
      var code = localStorage.getItem(REF_STORAGE_KEY);
      var ts = parseInt(localStorage.getItem(REF_TS_KEY) || '0', 10);
      if (!code || !ts) return null;
      var ageDays = (Date.now() - ts) / (1000 * 60 * 60 * 24);
      if (ageDays > REF_TTL_DAYS) {
        localStorage.removeItem(REF_STORAGE_KEY);
        localStorage.removeItem(REF_TS_KEY);
        return null;
      }
      return code;
    } catch (e) { return null; }
  };

  captureRefCouponFromUrl();

  function openCartDrawerFallback() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      drawer.classList.add('animate', 'active');
      document.body.classList.add('overflow-hidden');
      return;
    }
    // Sem cart-drawer: redireciona pra /cart
    window.location.href = '/cart';
  }

  function setLoadingState(btn, state) {
    btn.classList.remove('is-loading', 'is-success');
    if (state) btn.classList.add(state);
  }

  function getSectionsToRender() {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function addToCart(variantId, btn) {
    setLoadingState(btn, 'is-loading');
    btn.disabled = true;

    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: getSectionsToRender().join(','),
      sections_url: window.location.pathname
    };

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, status: r.status, data: data }; }); })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          var msg = result.data.message || result.data.description || 'Erro ao adicionar';
          console.error('[davila-quickadd] erro:', result.data);
          throw new Error(msg);
        }
        setLoadingState(btn, 'is-success');
        btn.disabled = false;

        // Notifica outras features (barra de progresso, etc)
        document.dispatchEvent(new CustomEvent('cart:updated'));

        // Atualiza o cart drawer com o HTML das sections
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(result.data);
        } else {
          openCartDrawerFallback();
        }

        // Volta ao estado normal apos 1.4s
        setTimeout(function () { setLoadingState(btn, null); }, 1400);
      })
      .catch(function (err) {
        setLoadingState(btn, null);
        btn.disabled = false;
        console.error('[davila-quickadd]', err);
        // Mostra mensagem rapida no botao
        var label = btn.querySelector('.davila-card__btn-label');
        if (label) {
          var original = label.textContent;
          label.textContent = 'Erro — tente novamente';
          setTimeout(function () { label.textContent = original; }, 2000);
        }
      });
  }

  function setupQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-davila-quickadd]');
      if (!btn) return;
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart(variantId, btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupQuickAdd);
  } else {
    setupQuickAdd();
  }
})();
